<div class="vor-order-title" style="background-color: #ededed;">
  <span class="order-text">{{'common.text_popup_title_emergency'|cxTranslate}}</span>

  <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
    <img src="/icons/close-kb.svg" alt=""  width="25" />
  </button>
</div>

<mat-dialog-content class="vor-order-dialog">
  <div class="container">
    <div id="checkout_inline_content1" class="checkout_inline_content1">
      <span class="emergency-colobox-close"></span>
      <div class="emergencyOrderwithoutstock">
        @for (item of _data.listEmergencyOrderWithoutStock; track item) {
          <p>
            {{'common.na_text_emergencyOrder_withoutstock_message1'|cxTranslate}}
            {{'common.na_text_emergencyOrder_withoutstock_message2'|cxTranslate}} <a class="ord-type-pcode" href="/p/800034">{{item}}</a>
            {{'common.na_text_emergencyOrder_withoutstock_message3'|cxTranslate}}<span class="ord-type-text">&nbsp;"{{_data.selectedOrderTypeName}}"&nbsp;</span>{{'common.na_text_emergencyOrder_withoutstock_message4'|cxTranslate}}<br><br>
          </p>
        }
      </div>
      <p>

        {{'common.na_text_emergencyOrder_withoutstock_message5'|cxTranslate}}<br><br>
        <span class="emgy-text">{{'common.na_text_emergencyOrder_withoutstock_message6'|cxTranslate}}</span>
      </p>
      <!--For NA  -->

    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-center">
  <div class="text-center">
    <a href="" [routerLink]="{ cxRoute: 'cart' } | cxUrl" class="btn btn-primary go-back-to-cart" mat-dialog-close>{{'common.go_back_to_cart_button_text'|cxTranslate}}</a>
    <button class="btn btn-primary ctn-chk-btn" mat-dialog-close>{{'common.continue_to_checkout_button_text'|cxTranslate}}</button>
  </div>
</mat-dialog-actions>